module.exports = __webpack_public_path__ + "static/img/img22.973a162.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img22.png
// module id = bVw9
// module chunks = 1